import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  sellers: {
    items: null,
    searchItems: [],
    request: [],
    isLoading: false
  },
  brands: {
    items: null,
    searchItems: [],
    request: [],
    isLoading: false
  },
  categories: {
    items: null,
    searchItems: [],
    request: [],
    isLoading: false
  },
  savedFilters: {
    model: null,
    items: []
  }
}

const getters = {
  categoriesGetter: (state) => {
    return state.categories
  }
}

const actions = {
  getFilterSellers ({ commit }, filter) {
    commit('SET_loadingSellers', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSeller',
        payload: {
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_filterSellers', response.data.payload.seller)
          }
          commit('SET_loadingSellers', false)
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  requestFilterSellers ({ commit }, filter) {
    commit('SET_requestSellers', filter.items)
  },
  getFilterBrands ({ commit }, filter) {
    commit('SET_loadingBrands', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getBrand',
        payload: {
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_filterBrands', response.data.payload.brand)
          }
          commit('SET_loadingBrands', false)
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  requestFilterBrands ({ commit }, filter) {
    commit('SET_requestBrands', filter.items)
  },
  getFilterCategories ({ commit }, filter) {
    commit('SET_loadingCategories', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getCategory',
        payload: {
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_filterCategories', response.data.payload.category)
          }
          commit('SET_loadingCategories', false)
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  requestFilterCategories ({ commit }, filter) {
    commit('SET_requestCategories', filter)
  },
  getSavedFilters ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getAnalyticsFilters',
        payload: {}
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_savedFilters', response.data.payload.filters)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getBySavedFilter ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getAnalyticsFilter',
        payload: {
          name: filter
        }
      })
        .then(response => {
          if (response.data.payload) {
            console.log('SAVED FILTERS', response.data.payload)
            commit('SET_analyticsFilters', {items: response.data.payload.filters, filter: filter})
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  saveFilter ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'saveAnalyticsFilters',
        payload: {
          filter_name_old: filter.old_name,
          filter_name_new: filter.new_name,
          sellers: filter.sellers,
          categories: filter.categories,
          brands: filter.brands
        }
      })
        .then(response => {
          if (response.data.payload) {
            console.log('saveAnalyticsFilters', response.data.payload)
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  deleteSavedFilter ({ commit }, name) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'deleteAnalyticsFilters',
        payload: {
          filter_name: name
        }
      })
        .then(response => {
          if (response) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_filterSellers (state, data) {
    state.sellers.items = data
  },
  SET_requestSellers (state, data) {
    state.sellers.request = data
  },
  SET_loadingSellers (state, bool) {
    state.sellers.isLoading = bool
  },
  SEARCH_sellers (state, e) {
    if (e.length !== 0) {
      const searchValue = e.toLowerCase()
      const items = []
      state.sellers.items.forEach(item => {
        if (item.name.toLowerCase().indexOf(searchValue) > -1) {
          items.unshift(item)
        }
      })
      state.sellers.searchItems = items
    }
  },
  SET_filterBrands (state, data) {
    state.brands.items = data
  },
  SET_requestBrands (state, data) {
    state.brands.request = data
  },
  SET_loadingBrands (state, bool) {
    state.brands.isLoading = bool
  },
  SEARCH_brands (state, e) {
    if (e.length !== 0) {
      state.brands.searchItems = []
      state.brands.items.forEach(item => {
        if (item.name.toLowerCase().includes(e.toLowerCase())) {
          state.brands.searchItems.unshift(item)
        }
      })
    }
  },
  SEARCH_categories (state, e) {
    state.categories.items.forEach(item => {
      item.show = e.length === 0
      if (item.category.name.toLowerCase().includes(e.toLowerCase())) {
        item.show = true
      }
      if (item.hasOwnProperty('children')) {
        for (let child in item.children) {
          item.children[child].show = e.length === 0
          if (item.children[child].category.name.toLowerCase().includes(e.toLowerCase())) {
            item.children[child].show = true
            item.show = true
          }
          for (let child2 in item.children[child].children) {
            item.children[child].children[child2].show = e.length === 0
            if (item.children[child].children[child2].name.toLowerCase().includes(e.toLowerCase())) {
              item.children[child].children[child2].show = true
              item.show = true
              item.children[child].show = true
            }
          }
        }
      }
    })
  },
  SET_filterCategories (state, data) {
    state.categories.items = data
  },
  SET_requestCategories (state, data) {
    if (data.length === 0) {
      state.categories.request = data
      return
    }
    if (data.status) { // If status is true(Add)
      state.categories.request.push(data.id)
    } else {
      let indexOfId = state.categories.request.findIndex((el) => el === data.id)
      state.categories.request.splice(indexOfId, 1)
    }
  },
  SET_loadingCategories (state, bool) {
    state.categories.isLoading = bool
  },
  SET_savedFilters (state, data) {
    state.savedFilters.items = []
    let arr = []
    data.forEach(item => {
      arr.push({name: item, id: item})
    })
    state.savedFilters.items = arr
  },
  SET_analyticsFilters (state, data) {
    state.savedFilters.model = data.filter
    if (data.items) {
      let filterKeys = Object.keys(data.items)
      filterKeys.forEach(key => {
        state[key].request = data.items[key]
      })
    }
  },
  RESET_filter (state) {
    state.sellers.request = []
    state.brands.request = []
    state.categories.request = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics/filterSeller.js